import type { ApiErrorResponse } from "@soulbyte/core";
import {
  createQueryClient,
  TanstackQueryProvider as CoreTanstackQueryProvider,
} from "@soulbyte/core";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { ReactNode } from "react";
import { toastError } from "./api/api.client";
import { signOut } from "./auth/auth.utils";

const queryClient = createQueryClient({
  onUnauthorized: signOut,
  onMutationError: (error: unknown) => {
    // Cancelled requests (e.g. removing a file mid-upload) are not failures.
    // createQueryClient now filters them out before this handler is reached —
    // kept as a local guard so a client built without that helper still cannot
    // toast a cancellation.
    if (error instanceof DOMException && error.name === "AbortError") {
      return;
    }

    const apiError = error as ApiErrorResponse;

    // Show a toast for non-unauthorized errors. Unauthorized errors are handled by the onUnauthorized handler.
    if (apiError?.error?.code !== "UNAUTHORIZED") {
      toastError(error);
    }
  },
});

export function TanstackQueryProvider({ children }: { children: ReactNode }) {
  return (
    <CoreTanstackQueryProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
    </CoreTanstackQueryProvider>
  );
}
